export function getUserFullName({ firstName = '', lastName = '', name = '', surname = '' } = {}) {
  return `${firstName || name} ${lastName || surname}`.trim();
}
